// extracted by mini-css-extract-plugin
module.exports = {"botao":"Botao_botao__52SW6"};